import React from 'react';
import { Position, NodeProps, useReactFlow } from '@xyflow/react';
import classNames from 'classnames';
import styles from './WorkflowNode.module.css';
import { useNodeClick } from '../hooks/useNodeClick';
import BaseNode from './BaseNode';
import i18n from '../../../i18n';

const getNodeLabel = (data: any): string => {
  if (typeof data?.config?.label === 'string') return data.config.label;
  if (typeof data?.label === 'string') return data.label;
  if (!data.config || Object.keys(data.config).length === 0) return i18n.t('workflow:legacy.empty');
  if (data.config.filepath) return i18n.t('workflow:legacy.csv');
  if (data.config.connection) return i18n.t('workflow:legacy.rdb');
  if (data.config.condition) return i18n.t('workflow:legacy.filter');
  if (data.config.joinType) return i18n.t('workflow:legacy.join');
  return i18n.t('workflow:legacy.workflow');
};

const WorkflowNode = ({ id, data, type, selected, ...props }: NodeProps) => {
  const onClick = useNodeClick(id);
  const reactFlowInstance = useReactFlow();
  
  const onDragStart = (event: React.DragEvent<HTMLDivElement>) => {
    // 드래그 시작 요소의 위치 정보 계산
    const targetRect = event.currentTarget.getBoundingClientRect();
    const offsetX = event.clientX - targetRect.left;
    const offsetY = event.clientY - targetRect.top;
    
    console.log('노드 드래그 시작 오프셋:', { offsetX, offsetY });
    
    // 드래그 데이터에 오프셋 정보 추가
    event.dataTransfer.setData('application/reactflow-node', JSON.stringify({
      type,
      data,
      source: 'canvas',
      id,
      offsetX,
      offsetY
    }));
    event.dataTransfer.effectAllowed = 'move';
  };

  // 빈노드 여부 판단
  const isEmptyNode = !data.config || Object.keys(data.config).length === 0;

  // 빈노드 아이콘
  const emptyIcon = (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" className="fill-gray-200" />
      <text x="12" y="16" textAnchor="middle" fontSize="16" fill="#888">?</text>
    </svg>
  );

  return (
    <BaseNode
      id={id}
      data={data}
      type={type}
      selected={selected}
      className={classNames(styles.node)}
      icon={isEmptyNode ? emptyIcon : null}
      label={getNodeLabel(data) || ''}
      {...props}
    />
  );
};

export default WorkflowNode; 